<template>
  <div>
    <h1>Credit Applications</h1>
    <table class="mt-10 clickable">
      <thead>
        <th>Name</th>
        <th>Amount</th>
        <th>State</th>
      </thead>
      <tbody>
        <tr
          v-for="factorRequest in factorRequests.data"
          :key="factorRequest.id"
          @click="
            $router.push({
              name: 'credit-application-detail',
              params: { id: factorRequest.id }
            })
          "
        >
          <td>{{ factorRequest.business.name }}</td>
          <td>
            {{ factorRequest.business.currency.code
            }}{{
              factorRequest.amount / factorRequest.business.currency.factor
            }}
          </td>
          <td>{{ factorRequest.state }}</td>
        </tr>
      </tbody>
    </table>

    <el-pagination
      class="mt-10"
      :current-page="factorRequests.pagination.currentPage"
      layout="pager"
      :total="factorRequests.pagination.totalCount"
      @current-change="pageChanged"
      :page-size="100"
      hide-on-single-page
    />
  </div>
</template>

<script>
import PaginatedPage from "./PaginatedPage";
import { FACTOR_REQUESTS_QUERY } from "@/api/queries";

export default {
  extends: PaginatedPage,
  apollo: {
    factorRequests: {
      query: FACTOR_REQUESTS_QUERY,
      variables: {
        page: 1
      }
    }
  },
  data() {
    return {
      factorRequests: {
        data: [],
        pagination: { currentPage: 1, totalCount: 0 }
      }
    };
  },
  methods: {
    queryData(page) {
      this.$apollo.queries.factorRequests.refetch({ page });
    }
  }
};
</script>
